import { useMemo, useRef } from 'react';

export const useNthChildrenPosition = (index: number) => {
  // Pour stockage de l'élément parent
  const parentRef = useRef<HTMLDivElement>(null);

  // Au changement d'index, récupération de l'enfant et
  // calcul de sa position relative par rapport au parent
  const position = useMemo(() => {
    const parentNode = parentRef.current;
    const childrenNode = parentNode?.children[index];
    if (parentNode == null || childrenNode == null) return null;
    const parentBoundingClientRect = parentNode.getBoundingClientRect();
    const childrenBoundingClientRect = childrenNode.getBoundingClientRect();
    const top = childrenBoundingClientRect.top - parentBoundingClientRect.top;
    const left = childrenBoundingClientRect.left - parentBoundingClientRect.left;
    const right = parentBoundingClientRect.right - childrenBoundingClientRect.right;
    const bottom = parentBoundingClientRect.bottom - childrenBoundingClientRect.bottom;
    return { top, left, right, bottom };
  }, [index]);

  return { parentRef, position };
};
